import { render, staticRenderFns } from "./takeUnit.vue?vue&type=template&id=713df6f4&scoped=true&"
import script from "./takeUnit.vue?vue&type=script&lang=js&"
export * from "./takeUnit.vue?vue&type=script&lang=js&"
import style0 from "./takeUnit.vue?vue&type=style&index=0&id=713df6f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713df6f4",
  null
  
)

export default component.exports